if (!Promise.withResolvers) {
  // eslint-disable-next-line no-console
  console.log('[Polyfill] Adicionando Promise.withResolvers');
  Promise.withResolvers = function <T>() {
    let resolve;
    let reject;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject } as PromiseWithResolvers<T>;
  };
}

export default Promise.withResolvers;
